import { habitatReachable, VETERAN_ENCOUNTERS, ZONES, type ZoneId } from "./map.ts";
import { SPECIES, SPECIES_IDS, type SpeciesId } from "./species.ts";

export interface HabitatRecord {
  zone: ZoneId;
  region: "all" | "north" | "south";
  lo: number;
  hi: number;
}

/**
 * Read the encounter source of truth; do not advertise still-locked southern beds, and do not
 * advertise a zone row whose only patches the trial has already turned veteran -- `habitatReachable`
 * is the map's own answer about which tiles really roll it.
 */
export function guideHabitats(id: SpeciesId, canopyCleared: boolean): HabitatRecord[] {
  const rows: HabitatRecord[] = [];
  const keep = (row: HabitatRecord) => {
    if (habitatReachable(id, row.zone, row.region, row.lo, row.hi, canopyCleared)) rows.push(row);
  };
  for (const zone of Object.keys(ZONES) as ZoneId[]) {
    const veteran = canopyCleared ? VETERAN_ENCOUNTERS[zone] : undefined;
    for (const row of ZONES[zone].encounters) {
      if (row.id === id) keep({ zone, region: veteran ? "north" : "all", lo: row.lo, hi: row.hi });
    }
    for (const row of veteran ?? []) {
      if (row.id === id) keep({ zone, region: "south", lo: row.lo, hi: row.hi });
    }
  }
  return rows;
}

export function guideEvolution(id: SpeciesId): string {
  const sp = SPECIES[id];
  const base = SPECIES_IDS.find(b => SPECIES[b].evolvesTo === id);
  const from = base ? `From ${SPECIES[base].name} at Lv${SPECIES[base].evolveLevel}.` : "";
  const next = sp.evolvesTo ? `Lv${sp.evolveLevel}: becomes ${SPECIES[sp.evolvesTo].name}.` : "";
  // Middle stages of three-stage lines read both ways: where they came from, then where they go.
  return [from, next].filter(Boolean).join(" ") || "No evolution recorded.";
}
